<dgx-components-modal-container
  class="plan-details-modal-container"
  data-testid="alert-modal"
></dgx-components-modal-container>

<ng-container *ngIf="!isCancellingFromClaims2">
  <claims-athome-myaccount-manage-my-repair
    [claims]="(claims$ | async)?.data"
    [appointmentsHistory]="(history$ | async)?.data?.result"
    [isHistoryShow]="isHistoryShow"
    [lastUpdated]="(claims$ | async)?.lastUpdated"
    [smartFixBanner]="banner$ | async"
    (viewPlanDetails)="viewPlanDetails()"
    (backButtonClicked)="backButtonClicked()"
    (rebookClaim)="rebookClaim($event)"
    (cancelClaim)="cancelClaim($event)"
    (createClaim)="createClaim($event)"
    (trackClaim)="trackClaim($event)"
    [isNewOrbitFlow]="isNewOrbitFlow"
  >
  </claims-athome-myaccount-manage-my-repair>
</ng-container>

<section
  *ngIf="isCancellingFromClaims2 || (buttonClicked | async)"
  class="loader"
>
  <div class="background"></div>
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="45" />
  </svg>
</section>
